import {useContaCommand} from '@/commandbar/commandBar.service'
import {useFavoriteLayouts} from '@/favourites/favourites.service'

const {registerCommand} = useContaCommand()

const {activateLayout, layouts} = useFavoriteLayouts()
layouts.forEach(layout => {
    registerCommand({
        type: 'favouriteLayout',
        typeLabel: 'Favoritter',
        label: layout.name,
        icon: layout.icon,
        key: layout.name,
        activate: () => {
            activateLayout(layout)
        },
        isActive: () => false
    })
})
